// extracted by mini-css-extract-plugin
export var actionButton = "_8r-0";
export var attachmentLine = "_8r-1";
export var fileInput = "_8r-2";
export var fileUploadWrapper = "_8r-4";
export var footer = "_8r-3";
export var modalContent = "_8r-5";
export var paperclip = "_8r-6";
export var quillEditor = "_8r-7";